import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
export default function ListaActivosView() {

    const theme = useTheme();
    return (
        <Box sx={{
            borderRadius: '10px',
            backgroundColor: theme.palette.background.paper,
            padding: '20px'
        }}>

            <Typography variant="h6" sx={{
                fontWeight: 'bold',
                marginBottom: '20px',
                fontSize: '20px'
            }}>
                Lista de Activos
            </Typography>
        </Box>
    )
}